import Container from "@components/ui-old/container";
import Layout from "@components/layout/layout";
import PageHeader from "@components/ui-old/page-header";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetStaticProps } from "next";
import React from "react";
import EventsCards from "@components/events/events-card";
export default function Events() {
  return <>
			<PageHeader pageHeader="text-page-events" data-sentry-element="PageHeader" data-sentry-source-file="events.tsx" />
			<Container data-sentry-element="Container" data-sentry-source-file="events.tsx">
				<div className="py-16 lg:py-20 px-0 max-w-5xl mx-auto space-y-4">
				 <EventsCards data-sentry-element="EventsCards" data-sentry-source-file="events.tsx" />
				</div>
			</Container>
		</>;
}
Events.Layout = Layout;
export const getStaticProps: GetStaticProps = async ({
  locale
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale!, ["common", "forms", "menu", "faq", "footer", 'swal']))
    }
  };
};